
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.439 11.925l7.246 7.344a1 1 0 11-1.424 1.405L7.315 12.62a1 1 0 01.007-1.412l7.947-7.89a1 1 0 011.409 1.42l-7.24 7.187z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    